import { render, staticRenderFns } from "./ColumnSelectorModal.vue?vue&type=template&id=224d8332&scoped=true&"
import script from "./ColumnSelectorModal.vue?vue&type=script&lang=js&"
export * from "./ColumnSelectorModal.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "224d8332",
  null
  
)

export default component.exports